// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1HhA6","col":"styles_col___kfNt"};